{
	"title": "Musisz się zalogować",
	"description": "Aby wyświetlić tę stronę, konieczne jest zalogowanie się. Zaloguj się. Następnie zostaniesz przekierowany(-a) na żądaną stronę.",
	"primaryButtonTitle": "Otwórz logowanie"
}
